<template>
  <base-page
    :title="$t('products.product_details')"
  >
    <template #actionButton>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            rounded
            color="primary"
            v-on="on"
          >
            {{ $t('products.add_product') }}
            <v-icon right>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-for="template in getTemplates">
            <v-list-item
              @click="$router.push({ name: 'create-product', query: { template: template.id } })"
            >
              <v-list-item-content>
                <v-list-item-title>{{ template.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>

    </template>

    <template #main>
      <product-list/>
    </template>
  </base-page>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BasePage from '@/views/BasePage.vue'
import ProductList from "../../components/Product/ProductList"

export default {
  components: {
    ProductList,
    BasePage,
  },
  computed: {
    ...mapGetters([ 'getTemplates' ]),
  },
  mounted() {
    this.initProducts()
    const payload = { type: 'product' }
    this.initTemplates(payload)
  },
  methods: {
    ...mapActions([ 'initProducts', 'initTemplates' ]),
    goto() {
      this.$router.push({ name: 'create-product' })
    }
  }
}
</script>
